import React, { useEffect, useState } from 'react';
import LargeContainer from '@/components/front-office/containers/LargeContainer';
import Header from '@/components/Header';
import Button from '@/components/Button';
import { usePaymentConfirmedContext } from '@/contexts/PaymentConfirmedContext';
import Loader from '@/components/common/Loader';
import axios from 'axios';
import { CopyIcon } from 'lucide-react';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
    const [order, setOrder] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [referralCode, setReferralCode] = useState(null);
    const { paymentConfirmedObject } = usePaymentConfirmedContext();

    useEffect(() => {
        const storedReferralCode = sessionStorage.getItem('referralCode');
        if (storedReferralCode) {
            setReferralCode(storedReferralCode);
            sessionStorage.removeItem('referralCode');
        }

        const fetchData = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/restaurants/${paymentConfirmedObject?.restaurantId}/orders/${paymentConfirmedObject?.orderReference}/details`);
                if (response.status === 200) {
                    setOrder(response.data);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };
        setTimeout(() => fetchData(), 4000);
    }, []);

    const handleCopyReferralCode = async () => {
        if (referralCode) {
            try {
                await navigator.clipboard.writeText(referralCode);
                toast.success('Code de parrainage copié dans le presse-papiers !');
            } catch (error) {
                console.error('Erreur lors de la copie:', error);
                toast.error('Erreur lors de la copie du code');
            }
        }
    };

    return (
        <LargeContainer withImage={true}>
            {order && (
                <Header useLogo={false} heading={`Merci pour votre commande`} />
            )}

            <div className="grid gap-2 mb-4 md:mb-2 text-sm md:text-xl">
                {order ? (
                    <>
                        <p>
                            Numéro de commande: <span className="capitalize font-bold text-lg">{order?.reference}</span>
                        </p>
                        <p>
                            Date de livraison le: <span className="capitalize font-bold text-lg">{order.delivery?.date}</span> dans la journée
                        </p>
                        <p>
                            Au: <span className="capitalize font-bold text-lg">{order.delivery?.address.address}</span>
                        </p>
                    </>
                ) : (
                    !isLoading ? <p>
                        Commande <span className="capitalize font-bold">{order?.reference}</span> non trouvée
                    </p>
                        : <>
                            <p className='capitalize font-bold mb-4'>
                                Chargement de la commande...
                            </p>

                            <Loader showParentDiv={false} textColor='text-primary' />
                        </>
                )}

                {referralCode && (
                    <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                        <p className="text-sm text-gray-700 mb-2">
                            <strong>Félicitations !</strong> Votre code de parrainage a été généré :
                        </p>
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <p className="text-xl font-bold text-green-600 tracking-widest">
                                {referralCode}
                            </p>
                            <button
                                type="button"
                                onClick={handleCopyReferralCode}
                                className="p-1 hover:bg-green-100 rounded transition-colors"
                                title="Copier le code"
                            >
                                <CopyIcon className="w-5 h-5 text-green-600" />
                            </button>
                        </div>
                        <p className="text-xs text-gray-600 mt-2 text-center">
                            Partagez ce code avec vos proches et gagnez 10€ pour chaque filleul !
                        </p>
                        <p className="text-xs text-gray-600 text-center">
                            Un email avec votre code vous a également été envoyé.
                        </p>
                    </div>
                )}
            </div>

            <Button
                text={"Retourner à l'accueil"}
                type={'Button'}
                action="button"
                handleClick={() => (window.location.href = '/')}
                disabled={true}
                withTopMargin={window.innerWidth > 768}
            />

        </LargeContainer>
    );
};

export default PaymentSuccess;
